import PropTypes from 'prop-types';
import TranslationUtil from '../../utils/TranslationUtil';
import ExperimentUtil from '../../utils/ExperimentUtil';
import { isCLLinkCollection } from '../../utils/ExperimentsUtil';
import JoinDetailsAction from '../../actions/joinDetails';

const BaseComponentProptypes = {
    placeholder: PropTypes.string.isRequired,
    ctaConfirm: PropTypes.string.isRequired,
    ctaCancel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};
const PropertyNotFoundModalProptypes = {
    titlePropertyNotFound: PropTypes.string.isRequired,
    descriptionPropertyNotFound: PropTypes.string.isRequired,
    ctaConfirmPropertyNotFound: PropTypes.string.isRequired
};
const PropertyPlaybackModalProptypes = {
    titlePropertyPlayback: PropTypes.string.isRequired,
    instructions: PropTypes.string.isRequired,
    ctaConfirmPropertyPlayback: PropTypes.string.isRequired,
    ctaCancelPropertyPlayback: PropTypes.string.isRequired
};

const ErrorHandlerProptypes = {
    invalid: PropTypes.string.isRequired,
    unsupported: PropTypes.string.isRequired,
    failure: PropTypes.string.isRequired
};

const ComponentProptypes = {
    baseComponent: PropTypes.shape(BaseComponentProptypes).isRequired,
    propertyPlayback: PropTypes.shape(PropertyPlaybackModalProptypes).isRequired,
    propertyNotFound: PropTypes.shape(PropertyNotFoundModalProptypes).isRequired,
    errors: PropTypes.shape(ErrorHandlerProptypes).isRequired,
    display: PropTypes.bool.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const {
        app
    } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const experimentUtil = new ExperimentUtil(app.experiments);
    const display = isCLLinkCollection(experimentUtil);
    return {
        baseComponent: {
            title: translations.getTranslation('competitorUrlComponent.base.title'),
            description: translations.getTranslation('competitorUrlComponent.base.description'),
            placeholder: translations.getTranslation('competitorUrlComponent.base.placeholder'),
            ctaConfirm: translations.getTranslation('competitorUrlComponent.base.ctaConfirm'),
            ctaCancel: translations.getTranslation('competitorUrlComponent.base.ctaCancel')
        },
        propertyPlayback: {
            titlePropertyPlayback: translations.getTranslation('competitorUrlComponent.propertyPlayback.title'),
            instructions: translations.getTranslation('competitorUrlComponent.propertyPlayback.instructions'),
            ctaConfirmPropertyPlayback: translations.getTranslation('competitorUrlComponent.propertyPlayback.ctaConfirm'),
            ctaCancelPropertyPlayback: translations.getTranslation('competitorUrlComponent.propertyPlayback.ctaCancel')
        },
        propertyNotFound: {
            titlePropertyNotFound: translations.getTranslation('competitorUrlComponent.propertyNotFound.title'),
            descriptionPropertyNotFound: translations.getTranslation('competitorUrlComponent.propertyNotFound.description'),
            ctaConfirmPropertyNotFound: translations.getTranslation('competitorUrlComponent.propertyNotFound.ctaConfirm')
        },
        errors: {
            invalid: translations.getTranslation('competitorUrlComponent.errors.invalid'),
            unsupported: translations.getTranslation('competitorUrlComponent.errors.unsupported'),
            failure: translations.getTranslation('compLeadForm.failDesc1')
        },
        display
    };
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
    setCompetitorUrl: competitorUrl => dispatch(JoinDetailsAction.setCompetitorUrl(competitorUrl)),
    setCompetitorUrlLoading: loading => dispatch(JoinDetailsAction.setCompetitorUrlLoading(loading))
});
/* istanbul ignore next */
const mapStateToPropsContext = (state) => {
    const {
        joinDetails: {
            competitorUrl
        }
    } = state;
    return {
        competitorUrl
    };
};

export {
    BaseComponentProptypes,
    PropertyNotFoundModalProptypes,
    PropertyPlaybackModalProptypes,
    ComponentProptypes,
    mapStateToProps,
    mapDispatchToProps,
    ErrorHandlerProptypes,
    mapStateToPropsContext
};
